import type { FC } from 'react';
import EmbedYoutube from '../../utils/EmbedYoutube/EmbedYoutube';
import { CoreJavaWrapper } from './CoreJava.styled';

interface CoreJavaProps {}

const CoreJava: FC<CoreJavaProps> = () => (
 <CoreJavaWrapper>	
   <header className="entry-header ">
      <h1 className="entry-title" itemProp="headline">Core Java</h1>			
   </header>
   <div className="entry-content clear" itemProp="text"  style={{height: 'auto !important'}}>
      <p className="text-align-justify">Java is the most popularly used object-oriented programming language. It was developed by Sun Microsystems in the year 1995. Java is fast and reliable to run on any platform. Above all, it is platform-independent, open-source, and a powerful programming language.</p>
      <br/>
      <EmbedYoutube videoType="video" videoList={["tORJqGGNAhA"]} />
      <br/>
      <br/>
      <p className="text-align-justify">In this section, the below-mentioned topics will be covered:</p>
      <ul className="text-align-justify">
         <li>Java Environment</li>
         <li>Strings</li>
         <li>Arrays</li>
         <li>Collections
            <ul>
               <li>List</li>
               <li>Queue</li>
               <li>Set</li>
               <li>Map</li>
               <li>Concurrent Collection</li>
            </ul>
         </li>
         <li>Exception Handling</li>
         <li>Multi-Threading </li>
         <li>Wrapper Class
            <ul>
               <li>Autoboxing &amp; Unboxing</li>
               <li>TypeCasting</li>
            </ul>
         </li>
         <li>Interface &amp; Abstract Class</li>
      </ul>
   </div>
 </CoreJavaWrapper>
);

export default CoreJava;
